import { render } from "./ProjectsList.vue?vue&type=template&id=7b4b47ba&scoped=true"
import script from "./ProjectsList.vue?vue&type=script&lang=js"
export * from "./ProjectsList.vue?vue&type=script&lang=js"

import "./ProjectsList.vue?vue&type=style&index=0&id=7b4b47ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4b47ba"]])

export default __exports__